export class PagingParameters<IFilterationCriteria>
{
  filterationCriteria: IFilterationCriteria;
  pageIndex: Number;
  pageSize: Number;
}
